import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";
import validations from "../../../../../../helpers/validations";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";

const AddFinancier = () => {
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");

  const FinancierInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            validation: {
              required: true,
            },
          },
        ]
      : []),
    {
      name: "financierName",
      label: "Finance Name",
      placeholder: "Enter Finance Name",
      type: "text",
      required: true,
      validation: validations.financierName({ required: true }),
      gridClass: "col-lg-4",
    },
    {
      name: "description",
      label: "Description",
      placeholder: "Enter Description",
      type: "text",
      required: true,
      validation: validations.description({ required: true }),
      gridClass: "col-lg-4",
    },
    // {
    //   name: "status",
    //   label: "Status",
    //   type: "dropdown",
    //   required: true,
    //   validation: {
    //     required: true,
    //   },
    //   options: [
    //     { label: "Active", value: "Active" },
    //     { label: "Inactive", value: "Inactive" },
    //   ],
    //   gridClass: "col-lg-4",
    // },
    {
      name: "status",
      label: "Status",
      type: "toggle",
      gridClass: "col-lg-1",
    },
  ];

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormSubmit = async (data) => {
    console.log("financerdata", data);

    // const errors = {};
    // let isValid = true;

    // // Validate form fields
    // FinancierInputs.forEach((field) => {
    //   if (field.validation && field.validation.required) {
    //     if (!formData[field.name]) {
    //       errors[field.name] = "This field is required";
    //       isValid = false;
    //     } else if (
    //       field.required &&
    //       field.validation &&
    //       field.validation.pattern &&
    //       !field.validation.pattern.test(formData[field.name])
    //     ) {
    //       errors[field.name] = field.validation.message;
    //       isValid = false;
    //     }
    //   }
    // });

    // // If validation fails, set errors and return
    // if (!isValid) {
    //   setValidationErrors(errors);
    //   return;
    // }

    const errors = {};
    let isValid = true;

    FinancierInputs.forEach((field) => {
      const value = formData[field.name];

      if (field.validation?.required && !value) {
        errors[field.name] = "This field is required";
        isValid = false;
        return;
      }

      if (
        value &&
        field.validation?.pattern &&
        !field.validation.pattern.test(value)
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
        return;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    console.log("data", data);

    showCustomAlert({
      title: "Success",
      text: "Are you sure you want to create a record in Financier.",
      confirmButtonText: "Financier created successfully.",
      icon: "success",
      confirmButtonText: "OK",

      callback: async () => {
        try {
          setLoading(true);
          const payload = {
            financer_name: data.financierName,
            financer_desc: data.description,
            // status: data.status === "Active" ? 1 : 0,
            status: data.status === true ? 1 : 0,
          };

          if (userType === "superadmin") {
            payload.business_partner_id = formData.business_partner_id;
          } else {
            payload.business_partner_id = businessPartnerId;
          }

          const response = await axiosInstance.post(
            "/financer/create",
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            },
          );

          console.log("API Response:", response.data);
          navigate("/admin/manage-product/financer");

          if (response.status === 200) {
            navigate("/admin/manage-product/financer"); // Navigate after user clicks OK
          }
        } catch (error) {
          console.error("Error submitting form:", error);

          const errorMessage = error.response?.data?.message;

          showErrorAlert({
            title: "Something went wrong",
            text:
              errorMessage ||
              "An error occurred while processing your request.",
            callback: () => {
              // Optional: code to execute after confirming the alert
              console.log("Error alert confirmed");
            },
          });
        } finally {
          setLoading(false);
        }
      },
    });
  };

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div
              className="backbutton mt-2 mb-2"
              // onClick={() => navigate("/admin/manage-product/financer")}
            >
              <img
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}
                src={backicon}
                alt="back"
              />
              <span className="backbtntitle">Add Financier</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter Finance Details
              </span>
              <DynamicForm
                formConfig={FinancierInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(FinancierInputs, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  FinancierInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={() => {
                  handleFormSubmit(formData);
                }}
              >
                {loading ? "Processing..." : "Submit"}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddFinancier;
